import {flow, get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {network as networkState} from './root.selector';

export const isConnected = createSelector(
  networkState,
  flow([
    get('isConnected'),
    //return true if null since isConected defaults to null for unknown networks
    (isConnected: any) => {
      if (isConnected === null) {
        return true;
      }
      return isConnected;
    },
  ]),
);
